module.exports = __webpack_public_path__ + "static/media/close.0300b7e0.jpg";